<template>
    <div class="status-success">
        <div class="status-indicator mb-4">
            <div class="pulse-dot">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_7283_117)">
                        <path d="M10 6.66667V10M10 13.3333H10.0083M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="#E35606" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_7283_117">
                            <rect width="20" height="20" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>

        <div class="text-container">
            <p>{{ title }}</p>
            <span>{{ text }}</span>
        </div>
    </div>
</template>
<script setup lang="ts">

defineProps({
    title: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ''
    }
});
</script>
<style scoped>
.status-success {
    @apply flex gap-3 cursor-pointer;
}
.status-indicator {
    @apply w-5 h-5  items-center justify-center flex;
}
.text-container {
    @apply flex flex-col items-start self-stretch gap-1;

    & > p {
        @apply text-sm font-semibold text-zinc-900;
    }

    & > span {
        @apply text-sm font-normal text-zinc-600;
    }
}

.pulse-dot {
    @apply relative flex items-center justify-center;
}

.pulse-dot :deep(svg),
.pulse-dot :deep(img) {
    @apply w-5 h-5;
}

.default-dot {
    @apply w-2 h-2 rounded-full bg-[#E35606];
}

.pulse-dot::before,
.pulse-dot::after {
    content: '';
    @apply absolute rounded-full transform -translate-x-1/2 -translate-y-1/2;
    @apply w-3/4 h-3/4 border-2 border-[#E35606] absolute top-1/2 left-1/2;
}

.pulse-dot::before {
    animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.pulse-dot::after {
    animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    animation-delay: 0.6s;
}

.pulse-dot:has(svg)::before,
.pulse-dot:has(img)::before,
.pulse-dot:has(svg)::after,
.pulse-dot:has(img)::after {
    animation-name: pulse-ring-with-icon;
}

@keyframes pulse-ring {
    0% {
        @apply w-full h-full opacity-100;
    }
    100% {
        @apply w-[300%] h-[300%] opacity-0;
    }
}

@keyframes pulse-ring-with-icon {
    0% {
        @apply w-full h-full opacity-100;
    }
    100% {
        @apply w-[200%] h-[200%] opacity-0;
    }
}
</style>
<style>
.Vue-Toastification__toast--success{
    @apply !bg-white border border-zinc-300 !shadow-sm rounded-lg p-4 items-start;
}
.Vue-Toastification__close-button{
    @apply !text-zinc-400 opacity-100;
}
</style>
